import { Helmet } from 'react-helmet-async';

const SITE_URL = window.location.origin;
const SITE_NAME = 'PushPro';
const DEFAULT_TITLE = 'PushPro - Create, Promote & Sell Digital Products';
const DEFAULT_DESC = 'PushPro helps creators create, promote, and route buyers to their own stores. AI-powered tools for images, videos, templates and more.';
const DEFAULT_IMAGE = `${SITE_URL}/images/og-image.png`;

export default function SEOHead({
  title,
  description,
  image,
  url,
  type = 'website',
  schema,
  noindex = false,
}) {
  const pageTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const pageDesc = description || DEFAULT_DESC;
  const pageImage = image || DEFAULT_IMAGE;
  const pageUrl = url || window.location.href;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={pageImage} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
